import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, Checkbox, Input, Row, Col } from 'antd';
import moment from 'moment';
import Table from '../../../../../components/Table';
import Modal from '../../../../../components/Modal';
import { poundsToPence } from '$app/utils/util';

const HeroModal = styled(Modal)`
  .ant-checkbox-wrapper {
    float: left;
  }
  .ant-table-row.selected {
    background: #e6f7ff;
  }
`;

const initialState = {
  heroName: '',
  filterHeroField: '',
  selectedHeroId: 0,
  driverRate: '',
  hasSubmit: false,
};

export default class AssignHeroModal extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  onRowClick(heroId, heroName, driverRate) {
    this.setState({
      selectedHeroId: heroId,
      heroName,
      driverRate: isNaN(driverRate) ? 0 : poundsToPence(driverRate),
    });
  }

  handleSubmit = () => {
    const { handleAssignHeroModalOk } = this.props;
    this.setState({ hasSubmit: true });
    const { selectedHeroId, driverRate } = this.state;
    handleAssignHeroModalOk(selectedHeroId, driverRate);
  };

  static getDerivedStateFromProps(props, state) {
    if (state.hasSubmit && !props.isLoading) {
      props.handleAssignHeroModalCancel();
      return initialState;
    }
    return null;
  }

  render() {
    const {
      isVisible,
      tableData,
      handleAssignHeroModalCancel,
      handleSameHeroModalChange,
      tripId,
      isLoading,
    } = this.props;
    const { filterHeroField } = this.state;
    const tableColumns = getTableColumns();

    const filteredData = tableData.filter((d) => {
      if (filterHeroField && filterHeroField.length > 0) {
        const nameMatch = (d.name || '').toLowerCase().indexOf(filterHeroField.toLowerCase()) >= 0;
        const emailMatch = (d.email || '').toLowerCase().indexOf(filterHeroField.toLowerCase()) >= 0;

        return nameMatch || emailMatch;
      }
      return true;
    });

    return (
      <HeroModal
        title="Assign a Hero"
        visible={isVisible}
        onCancel={handleAssignHeroModalCancel}
        width="900px"
        footer={[
          <Checkbox key="sameHero" defaultChecked onChange={handleSameHeroModalChange}>
            Use the same hero for delivery
          </Checkbox>,
          <Button
            icon="plus-circle"
            key="submit"
            type="primary"
            onClick={this.handleSubmit}
            disabled={!this.state.selectedHeroId || isLoading}
            loading={isLoading}
          >
            Assign Hero
          </Button>,
          <Button key="back" onClick={handleAssignHeroModalCancel}>
            Cancel
          </Button>,
        ]}
      >
        <Row>
          <Col span={18}>
            <strong>Trip id:</strong> {tripId}
          </Col>
          <Col span={6}>
            <Input
              placeholder="Search"
              allowClear
              value={filterHeroField}
              onChange={(e) => this.setState({ filterHeroField: e.target.value })}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <strong>Hero name:</strong> {this.state.heroName || 'Please select'}
          </Col>
        </Row>
        <Table
          dataSource={filteredData}
          columns={tableColumns}
          size="small"
          onRow={({ key, name, rate }) => ({
            onClick: () => this.onRowClick(key, name, rate),
          })}
          rowClassName={({ key }) => (key === this.state.selectedHeroId ? 'selected' : '')}
        />
        * This hero rate is calculated using distance based pricing.
      </HeroModal>
    );
  }
}

function getTableColumns() {
  return [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name?.localeCompare(b.name),
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      sorter: (a, b) => a.email?.localeCompare(b.email),
    },
    {
      title: 'Driver - Customer (miles)',
      dataIndex: 'distance',
      key: 'distance',
      sorter: (a, b) => a.distance - b.distance,
      defaultSortOrder: 'ascend',
      render: (distance, { actualDistance }) =>
        actualDistance ? distance.toFixed(2) : `~${distance.toFixed(2)}`,
    },
    {
      title: 'Customer - Garage (miles)',
      dataIndex: 'customerToGarageDistance',
      key: 'customerToGarageDistance',
      sorter: (a, b) => (a.customerToGarageDistance || 0) - (b.customerToGarageDistance || 0),
      defaultSortOrder: 'ascend',
      render: (customerToGarageDistance) => (customerToGarageDistance || 0).toFixed(2),
    },
    {
      title: 'Hero Rate (£)',
      dataIndex: 'rate',
      key: 'rate',
      sorter: (a, b) => a.pence - b.pence,
      render: (rate, { distanceBasedPricing }) => (distanceBasedPricing ? `${rate}*` : rate),
    },
    {
      title: 'Last active',
      dataIndex: 'lastActiveSince',
      key: 'lastActiveSince',
      render: (lastActiveSince) =>
        lastActiveSince.toLowerCase() !== 'new' && lastActiveSince.toLowerCase() !== 'never'
          ? moment(lastActiveSince).fromNow()
          : lastActiveSince,
    },
  ];
}
